import React from 'react'
import { Typography, Box } from '@material-ui/core'
import { Skeleton } from '@material-ui/lab'
import { themeConWeb } from '../../util/modernThemeConweb'

export const DailyHeader = ({ loading }) => {
  if (loading) {
    return <Skeleton height={50} width={100} />
  }

  return (
    <Box display="flex" flexDirection="row" alignItems="end" paddingTop={4} paddingBottom={4}>
      <Box style={{ paddingBottom: '4px' }}>
        <Typography
          variant="h6"
          style={{
            fontFamily: "'Roboto Slab', sans-serif",
            color: themeConWeb.color.two,
            textTransform: 'uppercase',
            fontVariantCaps: 'all-small-caps',
            fontWeight: 900,
            fontStyle: 'normal',
            fontSize: '36px',
            lineHeight: '24px',
            letterSpacing: '0.06em',
          }}
        >
          Daily
        </Typography>
      </Box>
    </Box>
  )
}

export default DailyHeader
